import { render, staticRenderFns } from "./RevokeInvite.vue?vue&type=template&id=e9e51bd6&"
import script from "./RevokeInvite.vue?vue&type=script&lang=js&"
export * from "./RevokeInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports